import { render, staticRenderFns } from "./RegularCard.vue?vue&type=template&id=6e75a706&scoped=true&lang=pug"
import script from "./RegularCard.vue?vue&type=script&lang=js"
export * from "./RegularCard.vue?vue&type=script&lang=js"
import style0 from "./RegularCard.vue?vue&type=style&index=0&id=6e75a706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e75a706",
  null
  
)

export default component.exports